import { Button } from "@/v2-components/ui/button";
import MenuIcon from "@/v2-components/core/icon/menu-icon";
import { Sheet, SheetContent, SheetTrigger } from "@/v2-components/ui/sheet";
import { LocaleView } from "@/v2-components/global-navigation-bar/navigation-menu-sheet/locale-view";
import { MenuView } from "@/v2-components/global-navigation-bar/navigation-menu-sheet/menu-view";
import { SwitchCase } from "@/v2-components/switch-case";
import { useEffect, useState } from "react";

export function NavigationMenuSheet() {
  const [view, setView] = useState<"menu" | "locale">("menu");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return setView("menu");
  }, [open]);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="darkgray-text"
          /* ⚠️ 데스크탑 네비와 **같은 브레이크포인트**여야 한다. 네비는 `desktop:block`(1280)
              인데 햄버거를 `laptop:hidden`(1024)으로 두면 **1024~1279 에 메뉴가 아예 없다**
              (실측: 1100·1279 에서 햄버거 0 · 데스크탑 네비 0). */
          className="-ml-[3px] desktop:hidden"
          size="none"
        >
          <MenuIcon />
        </Button>
      </SheetTrigger>
      <SheetContent
        side="left"
        /* ★시안(`29302:21466`)의 시트는 **화면 전체 폭**이다 — 360 뷰포트에서 360.
           `w-[90%]` 는 324 라 오른쪽에 배경이 비쳤고, 행의 우측 여백도 시안(`pr-16`)이
           아니라 시트 패딩으로 만들어져 있었다. 좌우 여백은 각 행이 스스로 갖는다.

           ⚠️ `p-0` 만 쓰면 안 된다 — 베이스가 `p-4 laptop:p-8` 이라 **다른 브레이크포인트는
           살아남는다**(docs/pitfalls.md #8). 1024~1279 도 이 시트를 쓰므로 둘 다 끈다. */
        className="flex w-full flex-col gap-0 overflow-hidden p-0 laptop:p-0"
      >
        <SwitchCase
          value={view}
          caseBy={{
            menu: (
              <MenuView
                onClose={() => setOpen(false)}
                onLanguageButtonClick={() => setView("locale")}
              />
            ),
            locale: <LocaleView onPrevious={() => setView("menu")} />,
          }}
          defaultComponent={
            <MenuView
              onClose={() => setOpen(false)}
              onLanguageButtonClick={() => setView("locale")}
            />
          }
        />
      </SheetContent>
    </Sheet>
  );
}
